import { ReactNode } from "react"

export enum Severity {
    LOW = "LOW",
    MEDIUM = "MEDIUM",
    HIGH = "HIGH"
}

export enum TableOperation {
    INSERT = "INSERT",
    DELETE = "DELETE",
    UPDATE = "UPDATE"
}

export enum AlertSource {
    FRONTEND = "FRONTEND",
    BACKEND = "BACKEND"
}

// Client-side representation of "Alert"
export type Alert = {
    id: number | string
    deviceId: number
    title: string
    timestamp: Date
    severity: Severity
    description: string
    resolutions: string | ReactNode
    silenced: boolean
    source: AlertSource
}

// Server-side representation of "Alert"
export type ServerAlert = {
    id: number
    alert_code: string
    is_silenced: boolean
    problem: string
    resolution: string
    severity: Severity
    timestamp: string
    title: string
    _device_id: number
}

type AlertTableUpdate = {
    operation: TableOperation
    data: string
}

export type AlertUpdate = Record<number, ServerAlert[]> | AlertTableUpdate

export const isIndividualAlertUpdate = (update: AlertUpdate): update is AlertTableUpdate => (update as AlertTableUpdate).operation !== undefined

export const toClientAlert = (serverAlert: ServerAlert): Alert => ({
    id: serverAlert.id,
    deviceId: serverAlert._device_id,
    source: AlertSource.BACKEND,
    title: serverAlert.title,
    timestamp: new Date(serverAlert.timestamp),
    description: serverAlert.problem,
    resolutions: serverAlert.resolution,
    severity: serverAlert.severity,
    silenced: serverAlert.is_silenced
})
